import { useQuery } from "@tanstack/react-query";
import { obtenerExpediente } from "@/lib/api";

/**
 * Carga el expediente con polling adaptativo:
 * - Refrescamos cada 10 s mientras el auditor LLM corre en background.
 * - Suspendemos polling cuando el expediente ya tiene `auditoria_llm`.
 * - No hay polling cuando el expediente todavía no tiene decisión.
 */
export function useExpediente(id: string) {
  return useQuery({
    queryKey: ["expediente", id],
    queryFn: () => obtenerExpediente(id),
    enabled: !!id,
    refetchInterval: (query) => {
      const exp = query.state.data;
      if (!exp) return false;
      if (!exp.decision) return false;
      if (exp.auditoria_llm) return false;
      return 10_000;
    },
  });
}
